<form #form="ngForm">
    <ng-container *ngIf="goal">
        <app-segment-header title="performance.goal-show.goalDetailsModal.mainTitle"></app-segment-header>

        <div class="app-grid">
            <mat-form-field class="columns-6 small-columns-12">
                <mat-label>{{ 'performance.goal-show.goalDetailsModal.formFields.title.label' | translate }}</mat-label>
                <input
                    matInput
                    type="text"
                    name="title"
                    required
                    placeholder="{{
                        'performance.goal-show.goalDetailsModal.formFields.title.placeholder' | translate
                    }}"
                    #title="ngModel"
                    [(ngModel)]="goal.title"
                />
                <mat-error *ngIf="title.invalid">{{ title.errors | formErrors }}</mat-error>
            </mat-form-field>
            <mat-form-field class="columns-6 small-columns-12">
                <mat-label appRemoveAriaOwns>{{
                    'performance.goal-show.goalDetailsModal.formFields.type.label' | translate
                }}</mat-label>
                <mat-select
                    name="is_shared"
                    placeholder="{{
                        'performance.goal-show.goalDetailsModal.formFields.type.options.selectAnOption' | translate
                    }}"
                    required
                    #isShared="ngModel"
                    [(ngModel)]="goal.isShared"
                >
                    <mat-option [value]="true">{{
                        'performance.goal-show.goalDetailsModal.formFields.type.options.sharedGoal' | translate
                    }}</mat-option>
                    <mat-option [value]="false">{{
                        'performance.goal-show.goalDetailsModal.formFields.type.options.perEmployee' | translate
                    }}</mat-option>
                </mat-select>
                <mat-error *ngIf="isShared">{{ isShared.errors | formErrors }}</mat-error>
            </mat-form-field>
        </div>

        <div class="app-grid">
            <mat-form-field class="columns-12">
                <mat-label>{{
                    'performance.goal-show.goalDetailsModal.formFields.description.label' | translate
                }}</mat-label>
                <textarea matInput name="description" [(ngModel)]="goal.description"></textarea>
            </mat-form-field>
        </div>

        <div class="app-grid">
            <mat-form-field class="columns-6 small-columns-12">
                <mat-label appRemoveAriaOwns>{{
                    'performance.goal-show.goalDetailsModal.formFields.frequency.label' | translate
                }}</mat-label>
                <mat-select name="reoccuring" [(ngModel)]="goal.reoccuring">
                    <mat-option value="never">
                        {{ 'performance.goal-show.goalDetailsModal.formFields.frequency.options.once' | translate }}
                    </mat-option>
                    <mat-option value="daily">
                        {{ 'performance.goal-show.goalDetailsModal.formFields.frequency.options.daily' | translate }}
                    </mat-option>
                    <mat-option value="weekly">
                        {{ 'performance.goal-show.goalDetailsModal.formFields.frequency.options.weekly' | translate }}
                    </mat-option>
                    <mat-option value="monthly">
                        {{ 'performance.goal-show.goalDetailsModal.formFields.frequency.options.monthly' | translate }}
                    </mat-option>
                    <mat-option value="quarterly">
                        {{
                            'performance.goal-show.goalDetailsModal.formFields.frequency.options.quarterly' | translate
                        }}
                    </mat-option>
                    <mat-option value="semiannually">
                        {{
                            'performance.goal-show.goalDetailsModal.formFields.frequency.options.semiannually'
                                | translate
                        }}
                    </mat-option>
                    <mat-option value="annually">
                        {{ 'performance.goal-show.goalDetailsModal.formFields.frequency.options.annually' | translate }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <app-segment-header title="performance.goal-show.goalDetailsModal.scheduleSectionTitle"></app-segment-header>
        <div class="app-grid">
            <mat-form-field class="columns-6 small-columns-12">
                <mat-label>{{
                    'performance.goal-show.goalDetailsModal.formFields.startAt.label' | translate
                }}</mat-label>
                <input
                    matInput
                    name="start_at"
                    #startAt="ngModel"
                    required
                    [ngModel]="goal.startAt | appDate: 'yyyy-MM-dd'"
                    (ngModelChange)="goal.startAt = $event"
                    placeholder="{{
                        'performance.goal-show.goalDetailsModal.formFields.startAt.placeholder' | translate
                    }}"
                    [matDatepicker]="startAtPicker"
                />
                <mat-datepicker-toggle matSuffix [for]="startAtPicker">
                    <mat-icon matDatepickerToggleIcon svgIcon="calendar"></mat-icon>
                </mat-datepicker-toggle>
                <mat-datepicker #startAtPicker></mat-datepicker>

                <mat-error *ngIf="startAt.invalid">{{ startAt.errors | formErrors }}</mat-error>
            </mat-form-field>

            <mat-form-field class="columns-6 small-columns-12">
                <mat-label>{{
                    'performance.goal-show.goalDetailsModal.formFields.dueDate.label' | translate
                }}</mat-label>
                <input
                    matInput
                    name="due_at"
                    #dueAt="ngModel"
                    [ngModel]="goal.dueAt | appDate: 'yyyy-MM-dd'"
                    (ngModelChange)="goal.dueAt = $event"
                    placeholder="{{
                        'performance.goal-show.goalDetailsModal.formFields.dueDate.placeholder' | translate
                    }}"
                    required
                    [matDatepicker]="dueAtPicker"
                />
                <mat-datepicker-toggle matSuffix [for]="dueAtPicker">
                    <mat-icon matDatepickerToggleIcon svgIcon="calendar"></mat-icon>
                </mat-datepicker-toggle>
                <mat-datepicker #dueAtPicker></mat-datepicker>

                <mat-error *ngIf="dueAt.invalid">{{ dueAt.errors | formErrors }}</mat-error>
            </mat-form-field>
        </div>

        <app-segment-header title="performance.goal-show.goalDetailsModal.metricsSectionTitle"></app-segment-header>
        <div class="app-grid">
            <mat-form-field class="columns-12">
                <mat-label appRemoveAriaOwns>{{
                    'performance.goal-show.goalDetailsModal.formFields.metricType.label' | translate
                }}</mat-label>
                <mat-select
                    name="metric_type"
                    required
                    #metric="ngModel"
                    [ngModel]="goal.metricType"
                    placeholder="{{
                        'performance.goal-show.goalDetailsModal.formFields.metricType.placeholder' | translate
                    }}"
                    (ngModelChange)="metricTypeChange($event)"
                >
                    <mat-option value="dollar">
                        {{ 'performance.goal-show.goalDetailsModal.formFields.metricType.options.dollar' | translate }}
                    </mat-option>
                    <mat-option value="percent">
                        {{ 'performance.goal-show.goalDetailsModal.formFields.metricType.options.percent' | translate }}
                    </mat-option>
                    <mat-option value="number">
                        {{ 'performance.goal-show.goalDetailsModal.formFields.metricType.options.number' | translate }}
                    </mat-option>
                    <mat-option value="binary">
                        {{ 'performance.goal-show.goalDetailsModal.formFields.metricType.options.binary' | translate }}
                    </mat-option>
                    <mat-option value="milestones">
                        {{
                            'performance.goal-show.goalDetailsModal.formFields.metricType.options.milestones'
                                | translate
                        }}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="metric.invalid">{{ metric.errors | formErrors }}</mat-error>
            </mat-form-field>

            <mat-form-field *ngIf="['dollar', 'number'].includes(goal.metricType)" class="columns-6 small-columns-12">
                <mat-label>{{
                    'performance.goal-show.goalDetailsModal.formFields.metricValue.label' | translate
                }}</mat-label>
                <input
                    matInput
                    type="number"
                    required
                    name="metric_value"
                    #metricValue="ngModel"
                    [(ngModel)]="goal.metricValue"
                />
                <mat-error *ngIf="metricValue.invalid">{{ metricValue.errors | formErrors }}</mat-error>
            </mat-form-field>
        </div>

        <ng-container *ngIf="['milestones'].includes(goal.metricType)">
            <div class="app-grid" *ngFor="let milestone of goal.metricMilestones; let index = index">
                <div class="columns-12 app-grid centered">
                    <mat-form-field class="columns-5">
                        <mat-label>{{
                            'performance.goal-show.goalDetailsModal.formFields.metricMilestones.label' | translate
                        }}</mat-label>
                        <input
                            matInput
                            type="text"
                            name="title-{{ index }}"
                            required
                            #title="ngModel"
                            placeholder="{{
                                'performance.goal-show.goalDetailsModal.formFields.metricMilestones.placeholder'
                                    | translate
                            }}"
                            [(ngModel)]="milestone.label"
                        />
                        <mat-error *ngIf="title.invalid">{{ title.errors | formErrors }}</mat-error>
                    </mat-form-field>

                    <mat-form-field class="columns-5">
                        <mat-label>{{
                            'performance.goal-show.goalDetailsModal.formFields.metricMilestonesDescription.label'
                                | translate
                        }}</mat-label>
                        <input
                            matInput
                            type="text"
                            name="description-{{ index }}"
                            placeholder="{{
                                'performance.goal-show.goalDetailsModal.formFields.metricMilestonesDescription.placeholder'
                                    | translate
                            }}"
                            [(ngModel)]="milestone.description"
                        />
                    </mat-form-field>

                    <div class="columns-2">
                        <mat-icon *ngIf="index !== 0" (click)="removeMilestone(index)" svgIcon="trash"></mat-icon>
                    </div>
                </div>
            </div>

            <ui-button
                type="link"
                (click)="$event.preventDefault(); $event.stopPropagation(); addMilestone()"
                class="align-left"
            >
                {{ 'performance.goal-show.goalDetailsModal.formFields.metricMilestones.addMilestone' | translate }}
            </ui-button>
        </ng-container>
    </ng-container>
</form>
